<div class="bc-toggle">
    <mat-slide-toggle [labelPosition]="'before'" [(ngModel)]="checked" [disabled]="disabled" (change)="onToggle()">
        {{getTitle()}}:
    </mat-slide-toggle>
</div>